'use client';

import React, { useState } from 'react';
import { Button } from 'components/ui/button';
import { ApplyFormDialog } from './ApplyFormDialog';
import { CommunitiesQuery } from 'generated/operations';
import { useRouter } from 'next/navigation';
import { MEMBER_ROUTES } from 'utils/routes';
import { useCommunity } from 'contexts/communityApp';
import { useTracking } from 'app/_tracking';

type CommunitiesNode = CommunitiesQuery['communities']['objs'][number];

interface CommunityCardFooterProps {
  community: CommunitiesNode;
}

export const CommunityCardFooter: React.FC<CommunityCardFooterProps> = ({ community }) => {
  const router = useRouter();
  const { chooseCommunity } = useCommunity();
  const { trackEvent } = useTracking();

  const [isApplyFormOpen, setIsApplyFormOpen] = useState(false);

  return (
    <>
      <div className='flex justify-end border-t border-t-gray-100 my-1 mx-4'>
        {community.hasJoined ? (
          <Button
            variant={'nakedBrandLink'}
            className={'text-small'}
            onClick={() => {
              chooseCommunity(community);
              router.push(MEMBER_ROUTES.SPACE.getPath(community.subdomain || community.domain || ''));
            }}
          >
            Open
          </Button>
        ) : community.hasApplied ? (
          <Button
            variant={'nakedBrandLink'}
            className={'text-small'}
            onClick={() => router.push(MEMBER_ROUTES.SPACE.getPath(community.subdomain || community.domain || ''))}
          >
            Applied
          </Button>
        ) : (
          <Button
            variant={'nakedBrandLink'}
            className={'text-small'}
            onClick={() => {
              trackEvent({ name: 'application_started' });
              setIsApplyFormOpen(true);
            }}
          >
            Join space
          </Button>
        )}
      </div>

      {!community.hasJoined && (
        <ApplyFormDialog
          community={community}
          open={isApplyFormOpen}
          onOpenChange={setIsApplyFormOpen}
        />
      )}
    </>
  );
};
